/* unplugin-vue-components disabled */import script from "./PBTabs.vue?vue&type=script&setup=true&lang=js"
export * from "./PBTabs.vue?vue&type=script&setup=true&lang=js"

import "./PBTabs.vue?vue&type=style&index=0&id=576b6d50&lang=css"

const __exports__ = script;

export default __exports__